<template>
  <div>
    <v-form ref="form" v-model="form.valid" lazy-validation @submit.prevent="onSubmit">
      <v-card outlined class="app-card">
        <v-card-title class="app-card-title">Taxas Avulsas</v-card-title>
        <v-card-text class="app-card-content">
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left" width="85%">Descrição</th>
                  <th class="text-center" width="15%">Valor</th>
                </tr>
              </thead>
              <tbody v-if="table.taxas">
                <tr v-for="item in table.taxas" :key="item.name">
                  <td>
                    <v-checkbox v-model="taxas" class="mx-2" :label="item.descricao" :value="item"></v-checkbox>
                  </td>
                  <td class="text-center">{{ item.valorTaxa | currency }}</td>
                </tr>
                <tr>
                  <td>Valor Total</td>
                  <td class="text-center">{{ table.totalTaxas | currency }}</td>
                </tr>
                <tr>
                  <td></td>
                  <td>
                    <v-btn
                      v-if="taxas.length > 0"
                      depressed
                      color="#3eb355"
                      class="white--text"
                      type="submit"
                    >Gerar Taxa</v-btn>
                  </td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <td class="text-center">
                    {{
                    !table.isLoading
                    ? "Ops! Ocorreram erros ao tentar buscar as taxas. Favor tente novamente."
                    : "Buscando taxas ..."
                    }}
                  </td>
                  <td></td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
          <div class="loading" v-if="isLoading">
            <v-progress-circular :size="25" color="primary" indeterminate></v-progress-circular>
          </div>
          <v-dialog v-model="modal.show" width="800">
            <v-card outlined class="app-card" style="margin-bottom:0px;">
              <v-card-title class="app-card-title" primary-title>Boleto da Taxa</v-card-title>

              <v-card-text class="app-card-content">
                <div style="height: 466px;">
                  <v-alert type="info">Faça o Download do boleto abaixo.</v-alert>
                  <p>
                    Caso não consiga visualizar o boleto,
                    <a
                      :href="modal.data.daeGerado"
                      target="_blank"
                    >Clique Aqui</a>
                  </p>
                  <iframe :src="modal.data.daeGerado" style="width: 100%; height: 374px;"></iframe>
                </div>
              </v-card-text>

              <v-divider></v-divider>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn depressed color="error" @click="modal.show = false">Fechar</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-card-text>
      </v-card>
      <v-card outlined class="app-card" v-if="hasVistoria || hasInclusionCar">
        <v-card-title class="app-card-title">Informação Veículo</v-card-title>
        <v-card-text class="app-card-content">
          <v-row>
            <v-col :md="4" :sm="4" :xs="12" cols="12" v-if="hasVistoria || hasInclusionCar">
              <v-text-field
                v-model="form.placa"
                label="Placa *"
                placeholder="Ex.: GDX-1B34"
                v-mask="'AAA-#X##'"
                :rules="[rules.required]"
                filled
                rounded
                dense
              ></v-text-field>
            </v-col>
            <v-col :md="4" :sm="4" :xs="12" cols="12" v-if="hasInclusionCar">
              <v-select
                v-model="form.tipoVeiculo"
                label="Tipo de Veículo *"
                placeholder="Selecione um tipo de veículo"
                :items="tipoVeiculo"
                :item-text="'descricao'"
                :item-value="'id'"
                :rules="[rules.required]"
                filled
                rounded
                dense
              ></v-select>
            </v-col>
            <v-col :md="4" :sm="4" :xs="12" cols="12" v-if="hasInclusionCar">
              <v-text-field
                v-model="form.carroceriaAnofabricacao"
                label="Ano Carrorecia"
                v-mask="'####'"
                placeholder="Digite o ano"
                filled
                rounded
                dense
              ></v-text-field>
            </v-col>
            <v-col :md="3" :sm="3" :xs="12" cols="12" v-if="hasInclusionCar">
              <v-text-field
                v-model="form.data"
                label="Data NF"
                placeholder="Ex:. 10/02/2008"
                v-mask="'##/##/####'"
                filled
                rounded
                dense
              ></v-text-field>
            </v-col>
            <v-col :md="5" :sm="5" :xs="12" cols="12" v-if="hasInclusionCar">
              <label>Área de Atuação *</label>
              <v-radio-group v-model="form.areaAtuacao" :rules="[rules.required]" row class="mt-0">
                <v-radio v-for="a in areasAtuacao" :key="a.id" :label="a.value" :value="a.id"></v-radio>
              </v-radio-group>
            </v-col>
            <v-col :md="4" :sm="4" :xs="12" cols="12" v-if="hasInclusionCar">
              <label>Serviço *</label>
              <v-radio-group v-model="form.servico" :rules="[rules.required]" row class="mt-0">
                <v-radio v-for="s in servicos" :key="s.id" :label="s.value" :value="s.id"></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
          <div class="loading" v-if="isLoading">
            <v-progress-circular :size="25" color="primary" indeterminate></v-progress-circular>
          </div>
        </v-card-text>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import { mask } from "vue-the-mask";
import TipoVeiculoService from "@/services/tipo_veiculo.service";
import TaxaService from "@/services/taxa.service";
import * as _ from "lodash";
import GlobalStore from "@/store/modules/global";
import TransportadoraAuthService from "@/services/transportadora.auth.service";

import { VUE_APP_PDF_URL, VUE_APP_FINANCEIRO_API_URL } from "@/commons/config";

export default {
  directives: {
    mask
  },
  name: "ListaTaxas",
  data() {
    return {
      currentTransportadora: null,
      table: {
        taxas: null,
        totalTaxas: 0,
        isLoading: false
      },
      taxas: [],
      tipoVeiculo: null,
      isLoading: false,
      modal: {
        show: false,
        data: {
          daeGerado: null
        }
      },
      form: {
        taxasAutos: [],
        placa: null,
        transportadoraId: null,
        tipoVeiculo: null,
        carroceriaAnofabricacao: null,
        data: null,
        areaAtuacao: null,
        servico: null,
        cnpj: null,
        token: null
      },
      hasVistoria: false,
      hasInclusionCar: false,
      rules: {
        required: value => !!value || "Esse campo deve ser preenchido",
        pattern: value =>
          !!value.match(/^([0-9])*\/[0-9]{4}$/) ||
          "Esse campo está fora do padrão"
      },
      areasAtuacao: [
        { id: 2, value: "Interurbano" }
      ],
      servicos: [
        { id: 1, value: "Regular" },
        { id: 2, value: "Fretamento" }
      ]
    };
  },
  methods: {
    getTaxas() {
      this.table.isLoading = true;
      TaxaService.getAll().subscribe(
        response => {
          this.table.taxas = response;
          this.table.isLoading = false;
        },
        error => {
          this.table.isLoading = false;
        }
      );
    },
    onSubmit() {
      const isValid = this.$refs.form.validate();

      if (isValid) {
        this.isLoading = true;
        TaxaService.emitirTaxa(this.form).subscribe(
          res => {
            this.isLoading = false;
            this.taxas = [];
            this.$refs.form.reset();
            this.modal.show = true;
            this.modal.data.daeGerado = `${VUE_APP_FINANCEIRO_API_URL}/api/pdf/detran/dae/${res}`;
          },
          error => {
            this.isLoading = false;
          }
        );
      }
    },
    loadTipoVeiculo() {
      TipoVeiculoService.getAll().subscribe(
        response => {
          this.tipoVeiculo = response;
        },
        error => {}
      );
    },
    loadTransportadora() {
      this.currentTransportadora =
        TransportadoraAuthService.currentTransportadoraValue;
      this.form.transportadoraId = this.currentTransportadora.id;
      this.form.cnpj = this.currentTransportadora.cnpj;
      this.form.token = this.currentTransportadora.token;
    },
    resetForm() {
      this.form = {
        taxasAutos: [],
        placa: null,
        transportadoraId: this.currentTransportadora.id,
        tipoVeiculo: null,
        carroceriaAnofabricacao: null,
        data: null,
        areaAtuacao: null,
        servico: null,
        cnpj: this.currentTransportadora.cnpj,
        token: this.currentTransportadora.token
      };
    }
  },
  mounted() {
    this.getTaxas();
    this.loadTipoVeiculo();
    this.loadTransportadora();
  },
  watch: {
    taxas: function(newValue, oldValue) {
      if (newValue && newValue.length > 0) {
        this.form.taxasAutos = newValue.map(taxa => taxa.codigoFinanceiro);
        this.table.totalTaxas = _.sumBy(newValue, "valorTaxa");
        this.hasVistoria = _.find(newValue, { id: 1056 });
        this.hasInclusionCar = _.find(newValue, { id: 1055 });
      } else {
        this.table.totalTaxas = 0;
        this.hasVistoria = null;
        this.hasInclusionCar = null;
        this.resetForm();
      }
    },
    hasVistoria: function(newValue, oldValue) {
      if (!newValue) {
        this.form.placa = null;
      }
    },
    hasInclusionCar: function(newValue, oldValue) {
      if (!newValue) {
        this.form.placa = null;
        (this.form.tipoVeiculo = null),
          (this.form.carroceriaAnofabricacao = null),
          (this.form.data = null),
          (this.form.areaAtuacao = null),
          (this.form.servico = null);
      }
    }
  }
};
</script>

<style></style>
